(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function getMainProduct() {
    return document.querySelector('product-info[id^="MainProduct-"]');
  }

  function getOriginalButton(productInfo) {
    return productInfo?.querySelector('product-form .product-form__submit[name="add"]');
  }

  function getButtonText(button) {
    return button?.querySelector('span:not(.sold-out-message)')?.textContent.trim() || 'Add to cart';
  }

  function getCurrentPrice(productInfo) {
    const price =
      productInfo?.querySelector('.price__sale .price-item--sale') ||
      productInfo?.querySelector('.price__regular .price-item--regular');
    return price?.textContent.trim() || '';
  }

  function setupMobileBuy(productInfo) {
    const originalButton = getOriginalButton(productInfo);
    if (!originalButton || document.querySelector('[data-kifl-mobile-buy]')) return;

    const bar = document.createElement('div');
    bar.className = 'kifl-mobile-buy';
    bar.dataset.kiflMobileBuy = '';
    bar.innerHTML = `
      <div class="kifl-mobile-buy__summary">
        <span class="kifl-mobile-buy__title"></span>
        <span class="kifl-mobile-buy__price"></span>
      </div>
      <button class="button button--primary kifl-mobile-buy__button" type="button"></button>
    `;

    const stickyButton = bar.querySelector('.kifl-mobile-buy__button');
    const title = productInfo.querySelector('.product__title h1')?.textContent.trim() || '';
    bar.querySelector('.kifl-mobile-buy__title').textContent = title;

    const sync = () => {
      const currentButton = getOriginalButton(productInfo);
      if (!currentButton) return;
      stickyButton.textContent = getButtonText(currentButton);
      stickyButton.disabled =
        currentButton.disabled || currentButton.getAttribute('aria-disabled') === 'true';
      bar.querySelector('.kifl-mobile-buy__price').textContent = getCurrentPrice(productInfo);
    };

    const updateVisibility = () => {
      const currentButton = getOriginalButton(productInfo);
      const shouldShow =
        mobileQuery.matches && currentButton && currentButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', Boolean(shouldShow));
      document.body.classList.toggle('kifl-mobile-buy-visible', Boolean(shouldShow));
    };

    let ticking = false;
    const requestVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    };

    stickyButton.addEventListener('click', () => {
      const currentButton = getOriginalButton(productInfo);
      if (currentButton && !currentButton.disabled) currentButton.click();
    });

    const observer = new MutationObserver(() => {
      sync();
      requestVisibilityUpdate();
    });
    observer.observe(productInfo, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    mobileQuery.addEventListener?.('change', requestVisibilityUpdate);
    document.body.appendChild(bar);
    sync();
    updateVisibility();
  }

  function setupEngravingValidation() {
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        const wrapper = document.getElementById('engraving-wrapper');
        const input = document.getElementById('engraving-name');
        if (
          !(form instanceof HTMLFormElement) ||
          !form.action.includes('/cart/add') ||
          !wrapper ||
          wrapper.offsetParent === null ||
          !input
        ) {
          return;
        }

        wrapper.querySelector('.kifl-engraving-error')?.remove();
        input.removeAttribute('aria-invalid');

        if (input.value.trim()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        input.setAttribute('aria-invalid', 'true');
        const error = document.createElement('p');
        error.className = 'kifl-engraving-error';
        error.setAttribute('role', 'alert');
        error.textContent = 'Enter a name before adding this engraved wallet to your cart.';
        input.insertAdjacentElement('afterend', error);
        input.focus();
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productInfo = getMainProduct();
    if (productInfo) setupMobileBuy(productInfo);
    setupEngravingValidation();
  });
})();
